import { useDigitalTrapsStore } from '@features/regional-overview/digital-traps/digital-traps.zustand';
import { processMultipleTrapFlightPredictions } from '@features/regional-overview/digital-traps/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useFlightPredictionsData = () => {
  const [t] = useTranslation();
  const trapGroups = useDigitalTrapsStore(state => state.trapGroups);
  const isLoading = useDigitalTrapsStore(state => state.isLoading);

  const networks = useMemo(() => {
    if (trapGroups.length === 0) {
      return [];
    }

    try {
      return processMultipleTrapFlightPredictions(trapGroups, t);
    } catch (error) {
      console.error('Error processing flight predictions:', error);
      return [];
    }
  }, [trapGroups, t]);

  return { networks, isLoading };
};
